
export default function RetreatHero() {
  return (
    <section 
      className="relative h-96 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/1d5f156b9b0ff6651203966515fbc887.jpg')`
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center text-white max-w-4xl px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Transformative Retreats</h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Immerse yourself in carefully curated retreat experiences designed to rejuvenate, inspire, and transform. 
            From wellness sanctuaries to adventure expeditions, find your perfect escape.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Browse Retreats
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Custom Retreat
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
